<template>
    <v-row class="ma-0">
        <v-col cols="6">
            <v-subheader class="primary--text pa-0 ma-0 h-auto mb-1 text-capitalize">Frequency</v-subheader>
            <v-autocomplete ref="frequency" v-model="model.frequency"
                :error-messages="$helpers.errorMsg('name', $v.model.frequency, 'Frequency')"
                hide-details="auto" placeholder="Frequency" required
                :items="frequencyLists" :menu-props="{ closeOnClick: true,  closeOnContentClick: true }"
                outlined
            >
            </v-autocomplete>
        </v-col>
        <v-col cols="6">
            <v-subheader class="primary--text pa-0 ma-0 h-auto mb-1 text-capitalize">Next Transaction Date</v-subheader>
            <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="slide-x-transition"
                offset-y
                bottom
                left
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field ref="next_due_date" v-bind="attrs" v-on="on" placeholder="Next Transaction Date" hide-details="auto"
                        :error-messages="model.next_due_date && !nxtTxnDate ? ['Invalid Date'] : []"
                        v-model="nxtTxnDate" outlined @input="clearDate($event)"></v-text-field>
                </template>
                <v-date-picker
                    v-model="model.next_due_date"
                    @input="dateChange"
                    color="primary lighten-1"
                    header-color="primary"
                ></v-date-picker>
            </v-menu>
        </v-col>
        <v-col cols="12">
            <v-card-actions class="pa-0">
                <v-row class="ma-0 pa-3" align="center" justify="end">
                    <v-btn :disabled="loading" color="primary" class="text-capitalize mr-3" @click="openNotify()">Save</v-btn>
                    <v-btn :disabled="loading" color="secondary" class="text-capitalize" @click="$emit('enableAct', false)">Cancel</v-btn>
                </v-row>
            </v-card-actions>
        </v-col>
        <notify-modal :loading="loading" :modalData="modalData" :open="openModal" @save="saveNotify" @close="openModal = false"/>
    </v-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions } from 'vuex';

export default {
    props: ['modelData'],
    emits: ['enableAct', 'modelUpdate'],
    components: {
        NotifyModal: () => import("@/pages/admin/sf-opportunity/components/NotifyModal"),
    },
    data: (vm) => ({
        menu: false,
        model: { frequency: '' },
        frequencyLists: [{text: 'Weekly', value: 'W'}, {text: 'Biweekly', value: 'BW'}, {text: 'Monthly', value: 'M'},
            {text: 'Bimonthly', value: 'BM'}, {text: 'Quarterly', value: 'Q'}, {text: 'Semiannual', value: 'SA'}, {text: 'Annual', value: 'A'}],
        today: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        openModal: false,
        loading: false,
        defaultModel: {},
        modalData: {
            name: 'save',
            items: [],
            tableNotFound: 'No Data Found!.',
            headers: [
                { text: 'Field', value: 'field' },
                { text: 'Previous', value: 'prev' },
                { text: 'New', value: 'new' }
            ]
        },
        nxtTxnDate: ''
    }),
    validations: {
        model: {
            frequency: { required },
        }
    },
    watch: {
        modelData(newVal) {
            this.defaultModel = newVal;
        }
    },
    created() {
        this.defaultModel = this.modelData;
    },
    methods: {
        ...mapActions(['donateChangeSchedule']),

        clearDate(evt){
            if(!evt || (evt && !this.$helpers.dateValidation(evt, 'DD-MM-YYYY'))) {
                this.nxtTxnDate = '';
                this.model.next_due_date = !evt ? null : this.today;
            }
        },
        dateChange() {
            this.nxtTxnDate = this.$helpers.getMomentDatas('DD-MM-YYYY', this.model.next_due_date);
            this.menu = false;
        },
        openNotify() {
            this.$v.$touch();
            if (this.$v && this.$v.$invalid || this.model.next_due_date && !this.nxtTxnDate) {
                this.$helpers.focusErrorElement(this.$v.model, this.$refs);
                return;
            }
            this.modalData.items = [{field: 'frequency', prev: this.defaultModel.frequency_label,
                new: (this.frequencyLists.find(item => item.value == this.model.frequency)).text }]
            if (this.model.next_due_date) {
                this.modalData.items.push({field: 'Next Transaction Date', prev: this.defaultModel.next_due_date,
                new: this.model.next_due_date})
            }
            this.openModal = true;
            this.$emit('enableAct', true);
        },
        saveNotify() {
            this.loading = true;
            this.donateChangeSchedule({id: this.defaultModel.id, reqData: this.model}).then(resp => {
                this.openModal = false;
                this.loading = false;
                this.$emit('modelUpdate', {field: 'frequency_label', value: this.modalData.items[0].new });
                this.$emit('enableAct', false);
            }).catch(err =>  this.loading = false)
        }
    }
}
</script>